module.exports = __webpack_public_path__ + "img/df25786.jpg";